module.exports = __webpack_public_path__ + "img/150.754ef54d.jpg";